module.exports = __webpack_public_path__ + "static/media/tag.cf7df42a.svg";